import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowLeft, ShoppingBag } from "lucide-react";
export default function CartContent() {
  return <section id="cart-content" className="bg-background py-16 md:py-24 min-h-[60vh]">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="mb-10 text-center space-y-4">
          <div className="flex justify-center mb-4">
            <div className="p-4 bg-primary/5 rounded-full">
              <ShoppingBag className="w-6 h-6 text-primary" />
            </div>
          </div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl text-primary tracking-tight">
            Il Tuo Carrello
          </h1>
          <p className="text-muted-foreground font-sans text-sm md:text-base max-w-2xl mx-auto">
            Rivedi i tuoi dolci scelti prima di procedere al checkout.
          </p>
        </div>

        <Card className="border border-border/40 shadow-sm bg-card/80 backdrop-blur-sm overflow-hidden">
          <CardContent className="p-6 md:p-12 min-h-[300px]">
            {}
            <div className="w-full woocommerce-cart-wrapper font-sans text-foreground">
              [woocommerce_cart]
            </div>
          </CardContent>
        </Card>

        <div className="mt-10 flex justify-center">
          <Link to="/CatalogPage">
            <Button variant="ghost" className="gap-2 text-primary hover:text-primary/80 hover:bg-primary/5 font-sans">
              <ArrowLeft className="w-4 h-4" />
              Torna al Catalogo
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}